"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-83592bee"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "oplus-table-wrapper" };
const _hoisted_3 = { class: "oplus-table" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("thead", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "から")
        ]),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "まで")
        ]),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "必要人数")
        ]),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "delete-btn-cell" }, [
            /*#__PURE__*/ (0, vue_2.createCommentVNode)(" Empty cell for delete column ")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_5 = ["value"];
const _hoisted_6 = ["value"];
const _hoisted_7 = ["value"];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("td", { class: "delete-btn-cell" }, null, -1 /* HOISTED */));
const _hoisted_9 = { class: "flex-justify-between" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-plus" }, null, -1 /* HOISTED */));
const _hoisted_11 = [
    _hoisted_10
];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../../vue/Modal.vue"));
const roleSectionTemplateRequest_1 = require("../../requests/roleSectionTemplateRequest");
const SectionTemplateModalRow_vue_1 = __importDefault(require("./SectionTemplateModalRow.vue"));
const common_1 = require("../../common/common");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const roles_1 = require("../../js/roles");
const roleSectionTemplate_1 = require("../model/roleSectionTemplate");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionTemplateModal',
    props: {
        roleTemplateId: {
            type: String,
        },
        isOverride: {
            type: Boolean,
            default: false,
        },
        selectedDate: {
            type: String,
            default: "",
        }
    },
    emits: ["emit-close-modal", "emit-new-template"],
    setup(__props, { emit: __emit }) {
        const meStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewMeStore, undefined);
        const selectedRole = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewSelectedRole, undefined);
        const templateStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewTemplateStore, undefined);
        const props = __props;
        const emits = __emit;
        const isLoading = (0, vue_3.ref)(false);
        const isVisible = (0, vue_3.ref)(true);
        const templateName = (0, vue_3.ref)("");
        const inputStart = (0, vue_3.ref)("");
        const inputEnd = (0, vue_3.ref)("");
        const inputCount = (0, vue_3.ref)("");
        const timeFrames = (0, vue_3.ref)([]);
        const templateTimeRequired = (0, vue_3.computed)(() => {
            if (props.roleTemplateId && templateStore?.value) {
                return templateStore.value.byId(String(props.roleTemplateId))?.requiredTimeSlots || [];
            }
            return [];
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? 'loading' : '';
        });
        const activeUserId = meStore?.getActiveUserId() || "";
        function handleInputStart(event) {
            const target = event.target;
            inputStart.value = (0, common_1.extractTimeAndMin)((0, common_1.fullWidthToAscii)(target.value), false).toString();
            addInputOnChange();
        }
        function handleInputEnd(event) {
            const target = event.target;
            inputEnd.value = (0, common_1.extractTimeAndMin)((0, common_1.fullWidthToAscii)(target.value), false).toString();
            addInputOnChange();
        }
        function handleInputCount(event) {
            const target = event.target;
            inputCount.value = (0, common_1.fullWidthToAscii)(target.value);
            addInputOnChange();
        }
        function addInputOnChange() {
            if (inputStart.value && inputEnd.value && inputCount.value) {
                const localTimeFrame = {
                    startTime: inputStart.value,
                    endTime: inputEnd.value,
                    requiredCount: inputCount.value,
                    index: -1,
                };
                addNewInputField(localTimeFrame);
                inputStart.value = "";
                inputEnd.value = "";
                inputCount.value = "";
            }
        }
        const computedTimeRequired = (0, vue_3.computed)(() => {
            templateTimeRequired.value?.forEach((t, i) => {
                const localData = {
                    startTime: (0, common_1.dateToKitchenTime)(t.startTime),
                    endTime: (0, common_1.dateToKitchenTime)(t.endTime),
                    requiredCount: String(t.requiredCount),
                    index: i,
                };
                timeFrames.value.push(localData);
            });
            return timeFrames.value;
        });
        function addNewInputField(values) {
            let localData = {
                startTime: '',
                endTime: '',
                requiredCount: '',
                index: computedTimeRequired.value.length - 1,
            };
            if (values) {
                localData.startTime = values.startTime;
                localData.endTime = values.endTime;
                localData.requiredCount = values.requiredCount;
            }
            computedTimeRequired.value.push(localData);
        }
        function sortTimeSlots() {
            return computedTimeRequired.value.filter(t => t.startTime != t.endTime).sort((a, b) => {
                return (0, common_1.kitchenTimeToDuration)(a.startTime, "minutes") - (0, common_1.kitchenTimeToDuration)(b.startTime, "minutes");
            });
        }
        // Validations
        function hasOverlappingTimeFrame() {
            const sortedIntervals = sortTimeSlots();
            for (let i = 0; i < sortedIntervals.length - 1; i++) {
                const end1 = (0, common_1.kitchenTimeToDuration)(sortedIntervals[i].endTime, "minutes");
                const start2 = (0, common_1.kitchenTimeToDuration)(sortedIntervals[i + 1].startTime, "minutes");
                if (start2 < end1) {
                    return true;
                }
            }
            return false;
        }
        function isValidInput(index) {
            const start = (0, common_1.kitchenTimeToDuration)(computedTimeRequired.value[index].startTime, "minutes");
            const end = (0, common_1.kitchenTimeToDuration)(computedTimeRequired.value[index].endTime, "minutes");
            return start < end;
        }
        function getValidcomputedTimeRequired() {
            const data = [];
            computedTimeRequired.value.forEach((t, i) => {
                if (isValidInput(i)) {
                    const d = {
                        startTime: t.startTime,
                        endTime: t.endTime,
                        requiredCount: parseInt(t.requiredCount) || 0
                    };
                    data.push(d);
                }
            });
            return data;
        }
        function closeModal() {
            isVisible.value = false;
            emits('emit-close-modal');
        }
        ;
        function onConfirm() {
            submitSectionTemplate();
        }
        ;
        function onCancel() {
            isVisible.value = false;
        }
        ;
        // Emit handlers
        function handleEdit(data) {
            const index = data.index;
            if (index !== -1) {
                if (data.startTime) {
                    computedTimeRequired.value[index].startTime = data.startTime;
                }
                if (data.endTime) {
                    computedTimeRequired.value[index].endTime = data.endTime;
                }
                computedTimeRequired.value[index].requiredCount = data.requiredCount;
            }
        }
        function handleTemplateRemove(data) {
            const idx = data.index;
            computedTimeRequired.value.splice(idx, 1);
        }
        async function submitSectionTemplate() {
            if (isLoading.value) {
                return;
            }
            if (hasOverlappingTimeFrame()) {
                return (0, roles_1.openAlertModal)("時間が重複しています。");
            }
            isLoading.value = true;
            try {
                const commonPayload = {
                    branchId: meStore?.getActiveBranchId() || "",
                    roleSectionId: parseInt(selectedRole?.value?.getId() || "0"),
                    name: templateName.value,
                    timeframes: getValidcomputedTimeRequired(),
                };
                const newTemplate = {
                    template: new roleSectionTemplate_1.RoleSectionTemplate({
                        id: 0,
                        roleSectionId: 0,
                    })
                };
                // Edit
                if (!props.isOverride && props.roleTemplateId) {
                    const payload = {
                        templateId: parseInt(props.roleTemplateId),
                        ...commonPayload
                    };
                    const updatedTemplate = await (0, roleSectionTemplateRequest_1.patchRoleSectionTemplates)(parseInt(activeUserId), payload);
                    newTemplate.template = updatedTemplate;
                }
                else {
                    // Create
                    const postPayload = {
                        ...commonPayload
                    };
                    if (props.isOverride) {
                        // Override
                        postPayload.overrides = parseInt(props.roleTemplateId || "0");
                        postPayload.overrideDay = props.selectedDate;
                    }
                    const createdTemplate = await (0, roleSectionTemplateRequest_1.postRoleSectionTemplates)(parseInt(activeUserId), postPayload);
                    newTemplate.template = createdTemplate;
                }
                const emitData = {
                    template: newTemplate.template,
                    overrideDate: props.selectedDate,
                    overrideTemplateId: props.roleTemplateId,
                };
                emits("emit-new-template", emitData);
            }
            catch (err) {
                (0, roles_1.openAlertModal)(err);
            }
            finally {
                isLoading.value = false;
                closeModal();
            }
        }
        ;
        (0, vue_3.onMounted)(() => {
            if (props.roleTemplateId) {
                templateName.value = templateStore?.value.byId(String(props.roleTemplateId))?.name || "";
            }
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    onConfirm: onConfirm,
                    onCancel: onCancel,
                    "has-title-divider": true
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" 時間毎のタイムプラン ")
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((templateName).value = $event)),
                                type: "text",
                                class: "section-template-title",
                                placeholder: "title"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelText, templateName.value]
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("table", _hoisted_3, [
                                    _hoisted_4,
                                    (0, vue_2.createElementVNode)("tbody", null, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(computedTimeRequired.value, (req, i) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SectionTemplateModalRow_vue_1.default, {
                                                "required-time-slot": req,
                                                index: i,
                                                key: `${req.startTime}-${i}`,
                                                onEmitTemplateRemove: handleTemplateRemove,
                                                onEmitTemplateTimeframe: handleEdit
                                            }, null, 8 /* PROPS */, ["required-time-slot", "index"]));
                                        }), 128 /* KEYED_FRAGMENT */)),
                                        (0, vue_2.createElementVNode)("tr", null, [
                                            (0, vue_2.createElementVNode)("td", null, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    value: inputStart.value,
                                                    onChange: _cache[1] || (_cache[1] = ($event) => (handleInputStart($event))),
                                                    class: "sect-template-input text-center",
                                                    type: "text",
                                                    placeholder: "9:00"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
                                            ]),
                                            (0, vue_2.createElementVNode)("td", null, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    value: inputEnd.value,
                                                    onChange: _cache[2] || (_cache[2] = ($event) => (handleInputEnd($event))),
                                                    class: "sect-template-input text-center",
                                                    type: "text",
                                                    placeholder: "10:00"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6)
                                            ]),
                                            (0, vue_2.createElementVNode)("td", null, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    value: inputCount.value,
                                                    onChange: _cache[3] || (_cache[3] = ($event) => (handleInputCount($event))),
                                                    class: "sect-template-input text-center",
                                                    type: "text",
                                                    placeholder: "4",
                                                    min: "0"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7)
                                            ]),
                                            _hoisted_8
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-slot-add-primary",
                                onClick: _cache[4] || (_cache[4] = ($event) => (addNewInputField(undefined)))
                            }, _hoisted_11),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                                onClick: onConfirm
                            }, "確定", 2 /* CLASS */)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
